import "src/css/widgets/widgets.css";
import { Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import CallStatus from "../queuedcallsdetail/callstatus";


function PortCard(props) {

    return (
        <span>
            <div className={"d-flex align-items-center bg-light-primary"} style={{ width: "178px", padding: "5px", margin: "5px", borderRadius: "10px" }} >
                <div className="w-100">
                    <div className="fs-7 text-muted fw-bold">
                        <Row>
                            <Col>
                                <div className="fs-7 text-dark fw-bold w-100">  {props.port.ext}</div>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={2}>
                                <CallStatus call={props.port} ></CallStatus>
                            </Col>
                            <Col>
                                {props.port.interlocutor}
                            </Col>
                        </Row>

                    </div>
                </div>

            </div>
        </span>
    )
}

const mapStateToProps = (state) => {
    return {
        token: state.supervisor.token
    };
};

export default connect(mapStateToProps, {})(PortCard);